import type { TailoredApiResponse } from './dto';
import type { TailoredData } from './types';

export const mapTailoredData = ({ data }: { data: TailoredApiResponse['data'] }): TailoredData => {
    return data;
};
